exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-51e5588c] .md-menu-content.md-select-menu {\n  width: 150px;\n}\n.modal-container[data-v-51e5588c] {\n  max-width: 600px;\n}\n", ""]);

// exports
